var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Connection Hub Mapping for Network / Local-TP ")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700"
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Hub Zone")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('model-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('hubzoneid')
    },
    attrs: {
      "options": _vm.listHubZoneData,
      "name": "hubzoneid",
      "placeholder": "Select Hub Zone"
    },
    on: {
      "input": function($event) {
        return _vm.getSourceHubNameList(_vm.hubzoneid, 'parent')
      }
    },
    model: {
      value: (_vm.hubzoneid),
      callback: function($$v) {
        _vm.hubzoneid = $$v
      },
      expression: "hubzoneid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hubzoneid')),
      expression: "errors.has('hubzoneid')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The Hub Zone field is required.")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.zoneLoading))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Route Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('model-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('routetype')
    },
    attrs: {
      "options": _vm.routetypelist,
      "name": "routetype",
      "placeholder": "Select Route Type"
    },
    on: {
      "input": function($event) {
        return _vm.getConnectionListByHubIDAndConnectionType()
      }
    },
    model: {
      value: (_vm.routetype),
      callback: function($$v) {
        _vm.routetype = $$v
      },
      expression: "routetype"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.routetype.text),
      expression: "!routetype.text"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "route"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Source Hub Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('sourceHubId')
    },
    attrs: {
      "options": _vm.listSourceHubNameData,
      "name": "sourceHubId",
      "placeholder": "Select Source Hub Name",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "select": _vm.selectSourceHub
    },
    model: {
      value: (_vm.sourceHubIdArr),
      callback: function($$v) {
        _vm.sourceHubIdArr = $$v
      },
      expression: "sourceHubIdArr"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.sourceHubLoading))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.sourceHubId.value),
      expression: "!sourceHubId.value"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "source"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Connection Name")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-map-signs'></i>"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listConnection,
      "label": "text",
      "track-by": "value",
      "custom-label": _vm.customLabel,
      "placeholder": "Select Connection",
      "show-labels": false,
      "hide-selected": true
    },
    on: {
      "select": _vm.resetHubSelection
    },
    scopedSlots: _vm._u([{
      key: "singleLabel",
      fn: function(props) {
        return [_c('span', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.text))])])]
      }
    }, {
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v(_vm._s(props.option.text))]), _vm._v(" "), _c('span', {
          staticClass: "option__small"
        }, [_vm._v("( " + _vm._s(props.option.FullConnectionName) + " )")])])]
      }
    }]),
    model: {
      value: (_vm.ConnectionID),
      callback: function($$v) {
        _vm.ConnectionID = $$v
      },
      expression: "ConnectionID"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.connectionLoading))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#1985ac",
      "font-size": "0.9em"
    }
  }, [_vm._v(_vm._s(_vm.ConnectionID.FullConnectionName))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.ConnectionID.value),
      expression: "!ConnectionID.value"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "conn"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        _vm.clickedMB = true
      }
    }
  }, [_vm._v(" Search")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.resetForm, function($event) {
        _vm.clickedMB = false
      }]
    }
  }, [_vm._v(" Reset")])])], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "card-body col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, [_c('legend', {
    staticStyle: {
      "background-color": "#c2cfd6"
    }
  }, [_vm._v("Mapped Destination Hubs : " + _vm._s(_vm.totalmappedhubs))])]), _vm._v(" "), _c('fieldset', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.connDestLoading
    },
    on: {
      "update:active": function($event) {
        _vm.connDestLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', [(_vm.hideFilter == 0) ? _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "margin-left": "0px",
      "width": "100%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.hideFilter = '1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter filter"
  }), _vm._v("Filter\n              ")]) : _vm._e(), _vm._v(" "), (_vm.hideFilter == 1) ? _c('div', {
    staticClass: "card-header",
    staticStyle: {
      "margin-left": "0px",
      "width": "100%",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.hideFilter = '0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-filter filter"
  }), _vm._v("Filter\n              ")]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    style: (("" + (_vm.hideFilter == '1' ? 'display: block !important; margin-top: 1%;' : 'display: none !important; margin-top: 1%;'))),
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-vv-scope": "form-3"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitHubSearch('hub')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Status")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('model-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.statusList,
      "name": "status",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.status.value),
      expression: "!status.value"
    }],
    staticClass: "text-danger",
    attrs: {
      "id": "status"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Destination Zone")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('b-input-group', [_c('model-select', {
    attrs: {
      "options": _vm.listHubZoneData,
      "name": "destHubZone",
      "placeholder": "Select Hub Zone",
      "data-vv-scope": "hub"
    },
    on: {
      "input": function($event) {
        return _vm.getSourceHubNameList(_vm.destHubZone, 'hubs')
      }
    },
    model: {
      value: (_vm.destHubZone),
      callback: function($$v) {
        _vm.destHubZone = $$v
      },
      expression: "destHubZone"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.zoneLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Destination Hub")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('Multiselect', {
    attrs: {
      "options": _vm.listDestHubNameData,
      "name": "destHubId",
      "placeholder": "Select Hub Name (ID)",
      "track-by": "value",
      "label": "text"
    },
    on: {
      "select": _vm.selectdestHubId
    },
    model: {
      value: (_vm.destHubIdArr),
      callback: function($$v) {
        _vm.destHubIdArr = $$v
      },
      expression: "destHubIdArr"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub City")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('model-select', {
    attrs: {
      "options": _vm.cityList,
      "name": "destCity",
      "placeholder": "Select Hub City"
    },
    model: {
      value: (_vm.destCity),
      callback: function($$v) {
        _vm.destCity = $$v
      },
      expression: "destCity"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.cityLoading))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Group City")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('model-select', {
    attrs: {
      "options": _vm.cityList,
      "name": "groupCity",
      "placeholder": "Select Group City"
    },
    model: {
      value: (_vm.groupCity),
      callback: function($$v) {
        _vm.groupCity = $$v
      },
      expression: "groupCity"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.cityLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Destination Group")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-area-chart'></i>"
    }
  }, [_c('b-input-group', [_c('multiselect', {
    attrs: {
      "options": _vm.hubGroupList,
      "track-by": "groupid",
      "label": "label",
      "custom-label": _vm.labelWithGroup,
      "multiple": true,
      "placeholder": "Select Destination Group",
      "hide-selected": true,
      "name": "searchHubId",
      "max": 5
    },
    model: {
      value: (_vm.destGroup),
      callback: function($$v) {
        _vm.destGroup = $$v
      },
      expression: "destGroup"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.groupLoading))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clickedMB),
      expression: "clickedMB"
    }],
    staticClass: "common-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" \n                              "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clickedMB),
      expression: "clickedMB"
    }],
    staticClass: "common-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetHubForm
    }
  }, [_vm._v("Reset")])])], 1)])])])])], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitHub('hubsave')
      }
    }
  }, [_c('div', {
    class: ("" + ((_vm.totalHubRows>0) ? 'showdest' : '')),
    staticStyle: {
      "overflow-x": "auto",
      "margin-top": "1%"
    }
  }, [_c('table', {
    staticClass: "table-hover datatables tbl",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticStyle: {
      "border": "0px",
      "width": "50%"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "99%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-left tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAllHub),
      expression: "checkAllHub"
    }],
    staticStyle: {
      "cursor": "pointer",
      "margin-left": "5%"
    },
    attrs: {
      "type": "checkbox",
      "id": "all"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAllHub) ? _vm._i(_vm.checkAllHub, null) > -1 : (_vm.checkAllHub)
    },
    on: {
      "click": _vm.checkHub,
      "change": function($event) {
        var $$a = _vm.checkAllHub,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAllHub = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAllHub = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAllHub = $$c
        }
      }
    }
  }), _vm._v("  Hub Name (ID)\n                              ")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Hub City ( Zone )")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Groups")])])])])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border": "0px",
      "width": "50%"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-left tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("  Hub Name (ID)")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Hub City ( Zone )")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader",
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Groups")])])])])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.connectionDestList), function(destination) {
    return _c('tr', _vm._l((destination), function(hub, index) {
      return _c('td', {
        attrs: {
          "colspan": "4"
        }
      }, [(destination.length > 0) ? _c('table', {
        staticStyle: {
          "width": "98%"
        }
      }, [_c('tbody', [_c('tr', [_c('td', {
        staticClass: "text-left",
        staticStyle: {
          "width": "30%"
        }
      }, [_c('input', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "type": "checkbox",
          "id": hub.hubid
        },
        domProps: {
          "checked": _vm.checked[hub.hubid]
        },
        on: {
          "change": _vm.updateCheckDest
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "for": hub.hubid
        }
      }, [_vm._v(" " + _vm._s(hub.hubname) + " (" + _vm._s(hub.hubid) + ")")])]), _vm._v(" "), _c('td', {
        staticClass: "text-left",
        staticStyle: {
          "width": "30%"
        }
      }, [_c('label', {
        attrs: {
          "for": hub.hubid
        }
      }, [_vm._v(_vm._s(hub.CityName) + " ( " + _vm._s(hub.HubZoneName) + " )")])]), _vm._v(" "), _c('td', {
        staticClass: "text-left",
        staticStyle: {
          "width": "40%"
        }
      }, [_c('label', {
        attrs: {
          "for": hub.hubid
        }
      }, [_vm._v(_vm._s(hub.groupname))])])])])]) : _vm._e()])
    }), 0)
  }), _vm._v(" "), (_vm.connectionDestList.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer",
    staticStyle: {
      "padding": "0.25rem"
    }
  }, [_c('span', [_vm._v("Filtered records: " + _vm._s(_vm.totalHubRows))]), _c('span', {
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_vm._v("Selected records: " + _vm._s(_vm.modelArr.length))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelArr.length > 0 && _vm.clickedMB),
      expression: "modelArr.length>0 && clickedMB"
    }],
    staticClass: "common-success",
    staticStyle: {
      "margin-left": "45%"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v("  "), _c('b', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelArr.length > 0 && _vm.clickedMB),
      expression: "modelArr.length>0 && clickedMB"
    }]
  }, [_vm._v("|")]), _vm._v("  \n                "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modelArr.length > 0 && _vm.clickedMB),
      expression: "modelArr.length>0 && clickedMB"
    }],
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportDestinations
    }
  }, [_vm._v("Export")])])])], 1)], 1)])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addmodalShow = false
      }
    },
    model: {
      value: (_vm.addmodalShow),
      callback: function($$v) {
        _vm.addmodalShow = $$v
      },
      expression: "addmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Do you want to allocate destinations to connection?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [_vm.takeAction, function($event) {
        _vm.addmodalShow = false
      }]
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bee1a56","hasScoped":true}!./src/views/components/connectionhubfornetworknew/connectionhubfornetworknew.component.html
// module id = 1522
// module chunks = 2